import {Box, Chip, Typography} from "@mui/material";
import {Grid} from "@mui/system";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

import dotsBackground_dark from "assets/images/dots-background-dark.svg";
import dotsBackground_light from "assets/images/dots-background-light.svg";

import {CustomButton} from "ui";
import StyledBox from "./AccessError.styles";

type Props = {
  type: string;
  title: string;
  message: string;
  imageSrc: string;
  imagetranslate?: string;
  imagewidhtonsmallscreens?: string;
  imagemargintop?: string;
  customButton?: React.ReactNode;
};

const AccessError = (props: Props) => {
  const {
    type,
    title,
    message,
    imageSrc,
    imagetranslate = "25%",
    imagewidhtonsmallscreens = "75%",
    imagemargintop = "42px",
    customButton,
  } = props;
  const {
    userInfo: {
      settings: {darkMode},
    },
  } = useSelector((state: any) => state.stateUserInfo);
  const history = useHistory();
  return (
    <StyledBox
      imagetranslate={imagetranslate}
      imagemargintop={imagemargintop}
      imagewidhtonsmallscreens={imagewidhtonsmallscreens}
    >
      <Box className="accessDenied__dots">
        <Box
          component="img"
          src={darkMode ? dotsBackground_dark : dotsBackground_light}
        />
      </Box>
      <Box className="accessDenied__textArea">
        <Grid container>
          <Grid size={12}>
            <Chip label={type} className="accessDenied__textArea--chip" />
          </Grid>
          <Grid size={12} className="accessDenied__textArea--title">
            <Typography variant="h3">{title}</Typography>
          </Grid>
          <Grid size={12} className="accessDenied__textArea--body">
            <Typography variant="body1">{message}</Typography>
          </Grid>
          <Grid size={12} mt="32px" className="accessDenied__textArea--action">
            {!customButton && (
              <>
                <CustomButton
                  startIcon="arrow_back"
                  sx={{height: "44px", textTransform: "capitalize"}}
                  onClickFn={() => history.go(-2)}
                >
                  Voltar para a página anterior
                </CustomButton>
                <CustomButton
                  startIcon="dashboard"
                  sx={{
                    height: "44px",
                    textTransform: "capitalize",
                  }}
                  onClickFn={() => history.push(`/dashboards`)}
                >
                  Ir para a dashboard
                </CustomButton>
              </>
            )}
            {customButton}
          </Grid>
        </Grid>
      </Box>
      <Box className="accessDenied__imageContainer">
        <Box
          component="img"
          alt="error image"
          src={imageSrc}
          className="accessDenied__imageContainer--image"
        />
      </Box>
    </StyledBox>
  );
};

export default AccessError;
